export * from "./animations";

export const theme = {
  transitions: {
    default: "200ms ease-in-out",
  },
};
